import { ActionTypesFactory } from "../../utils";

export const Employees = ActionTypesFactory("Employees", "Employees");
export const EmployeesStatus = ActionTypesFactory(
  "EmployeesStatus",
  "Employees"
);
export const AddEmployees = ActionTypesFactory("AddEmployees", "Employees");
export const UpdateEmployees = ActionTypesFactory(
  "UpdateEmployees",
  "Employees"
);
export const DeleteEmployees = ActionTypesFactory(
  "DeleteEmployees",
  "Employees"
);
export const DownloadBulkLink = ActionTypesFactory(
  "DownloadBulkLink",
  "Employees"
);
export const UploadBulk = ActionTypesFactory("UploadBulk", "Employees");
export const GetProfile = ActionTypesFactory("Profile", "Employees");
export const GetUserFields = ActionTypesFactory("GetUserFields", "Employees");
export const GetUsersList = ActionTypesFactory("GetUsersList", "Employees");

export const getProfile = (payload) => {
  return {
    type: GetProfile.REQUEST,
    payload,
  };
};

export const usersList = (payload) => {
  return {
    type: GetUsersList.REQUEST,
    payload,
  };
};

export const uploadBulkEmployees = (payload) => {
  return {
    type: UploadBulk.REQUEST,
    payload,
  };
};

export const downloadBulkEmployees = () => {
  return {
    type: DownloadBulkLink.REQUEST,
  };
};

export const getUserFields = () => {
  return {
    type: GetUserFields.REQUEST,
  };
};

export const employees = (payload) => {
  return {
    type: Employees.REQUEST,
    payload,
  };
};

export const employeesStatus = (payload) => {
  return {
    type: EmployeesStatus.REQUEST,
    payload,
  };
};

export const addEmployees = (payload) => {
  return {
    type: AddEmployees.REQUEST,
    payload,
  };
};

export const updateEmployees = (payload) => {
  return {
    type: UpdateEmployees.REQUEST,
    payload,
  };
};

export const deleteEmployees = (payload) => {
  return {
    type: DeleteEmployees.REQUEST,
    payload,
  };
};

// export const commits = (payload) => {
//   let str = "";
//   Object.keys(payload).forEach((item) => {
//     str = str + `${item}:${payload[item]} `;
//   });
//   payload = encodeURIComponent(str);
//   return {
//     type: Commits.REQUEST,
//     payload,
//   };
// };
